import { createRoot } from 'react-dom/client';
import * as React from "react";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'src/stores/AppStore';
import './index.css';
import App from './App';
import "react-tooltip/dist/react-tooltip.css";
import './i18n';

  const container = document.getElementById('root');
  const root = createRoot(container!); 

  root.render(
    // <React.StrictMode>
      <BrowserRouter>
        {/* @ts-ignore */}
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    // </React.StrictMode>
  )
